import React from 'react'
import styles from './CustomCard.module.scss'
import { Card, CardProps } from 'antd'

interface CustomCardProps extends CardProps {
    children: React.ReactNode
    cardTitle?: string | React.ReactNode
    loading?: boolean
    extra?: React.ReactNode
    className?: any
}

const CustomCard: React.FC<CustomCardProps> = (props) => {
  const {
    children,
    cardTitle,
    loading = false,
    extra = null,
    className = '',
    ...restProps
  } = props
  return (
    <div className={`${styles['custom-padding']}`}>
      <Card
        title={cardTitle}
        bordered={true}
        className={`${styles['custom-radius']} ${className}`}
        loading={loading}
        extra={extra}
        {...restProps}
      >
        {children}
      </Card>
    </div>
  )
}

export default CustomCard
